import { SidebarItem } from '@backstage/core-components';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import BuildIcon from '@material-ui/icons/Build';
import { useEffect, useState } from 'react';

export const OpsicleUserLink = () => {
  const identityApi = useApi(identityApiRef);
  const [userEntityRef, setUserEntityRef] = useState<string | null>(null);

  useEffect(() => {
    const getUserId = async () => {
      try {
        const userIdentity = await identityApi.getBackstageIdentity();
        setUserEntityRef(userIdentity.userEntityRef);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to get user identity:', error);
      }
    };

    getUserId();
  }, [identityApi]);

  // Extract user ID from userEntityRef (e.g., "user:default/ngatla" -> "ngatla")
  const userId = userEntityRef?.split('/').pop();

  if (!userId) {
    // Don't render the link if we don't have a user ID
    return null;
  }

  return (
    <SidebarItem
      icon={BuildIcon}
      to={`catalog/default/user/${userId}/operations`}
      text="Operations (Alpha)"
    />
  );
};
